const VenueCardSkeleton = () => (
  <div
    className='bg-white border border-[#bfbfbf] rounded-lg overflow-hidden 
  flex flex-col sm:flex-row sm:items-stretch sm:gap-[19px] sm:p-4'>
    <div className='relative shrink-0 w-full h-48 sm:w-[250px] sm:h-auto sm:rounded-xl bg-[#e8e8e8] animate-pulse' />

    <div className='flex-1 min-w-0 flex flex-col p-4 sm:py-[13px] sm:pr-4 sm:pl-0 gap-3'>
      <div className='flex flex-col gap-2'>
        <div className='h-6 w-3/5 rounded bg-[#e8e8e8] animate-pulse' />
        <div className='h-4 w-2/5 rounded bg-[#e8e8e8] animate-pulse' />
      </div>
      <div className='h-4 w-1/4 rounded bg-[#e8e8e8] animate-pulse' />
      <div className='flex flex-col gap-1.5'>
        <div className='h-4 w-full rounded bg-[#e8e8e8] animate-pulse' />
        <div className='h-4 w-full rounded bg-[#e8e8e8] animate-pulse' />
        <div className='h-4 w-3/4 rounded bg-[#e8e8e8] animate-pulse' />
      </div>
      <div className='h-8 w-[180px] rounded-[4px] bg-[#e8e8e8] animate-pulse mt-1' />
    </div>
  </div>
)

export default VenueCardSkeleton
